module.exports = __webpack_public_path__ + "media/images/Loupe-bc8a31f2deac700de4050a0a5f2fc26b.png";